module.exports = __webpack_public_path__ + "static/img/5793_phase_function_Paper_PointsHejduk_Prediction.cb01c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5793_phase_function_Paper_PointsHejduk_Prediction.png
// module id = KI7/
// module chunks = 0